import { render, staticRenderFns } from "./AgreementManagement.vue?vue&type=template&id=8f510d5e&scoped=true&"
import script from "./AgreementManagement.vue?vue&type=script&lang=js&"
export * from "./AgreementManagement.vue?vue&type=script&lang=js&"
import style0 from "./AgreementManagement.vue?vue&type=style&index=0&id=8f510d5e&scoped=true&lang=css&"
import style1 from "./AgreementManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f510d5e",
  null
  
)

export default component.exports